const posts = [
  {
    code: 'post1',
    caption: 'Lunch #hamont',
    likes: 56,
    id: '1161022966406956503',
    display_src: `https://i.ibb.co/rtMp6gt/14.jpg`,
  },

  {
    code: 'post2',
    caption: 'Snow! ⛄️🌨❄️ #lifewithsnickers',
    likes: 59,
    id: '1160844458347054781',
    display_src: `https://i.ibb.co/zrMbQmQ/15.jpg`,
  },
  {
    code: 'post3',
    caption:
      'Cleaned my office and mounted my recording gear overhead. Stoked for 2016!',
    likes: 79,
    id: '1154606670337393752',
    display_src: `https://i.ibb.co/VWWJ4h1/16.jpg`,
  },
  {
    code: 'post4',
    caption: 'Making baby pancakes for one early rising baby. ☕️🍴',
    likes: 47,
    id: '1157179863266871229',
    display_src: `https://i.ibb.co/NTgdhHJ/7.jpg`,
  },
  {
    code: 'post5',
    caption:
      "New Stickers just came in. I'll do another mailing in a few weeks if you want some. #javascript",
    likes: 66,
    id: '1126293663140399053',
    display_src: `https://i.ibb.co/XCxHd0V/2.jpg`,
  },
  {
    code: 'post6',
    caption: 'Tacos for breakfast. I love you Austin. 🇺🇸',
    likes: 33,
    id: '1117418173361145365',
    display_src: `https://i.ibb.co/99fvbqn/13.jpg`,
  },
  {
    code: 'post7',
    caption:
      "Tried poke for the first time at @pokehbar. Delicious! It's like a bowl of sushi",
    likes: 30,
    id: '1162418651480049646',
    display_src: `https://i.ibb.co/Lv3KY01/8.jpg`,
  },

  {
    code: 'post8',
    caption: "Brunchin'",
    likes: 40,
    id: '1152964002473690553',
    display_src: `https://i.ibb.co/Phjj7JP/28.jpg`,
  },
  {
    code: 'post9',
    caption:
      '2015 can be summed up with one baby and a many lines of code. And sometimes a coding baby. 👶🏼⌨',
    likes: 62,
    id: '1150824171912152320',
    display_src: `https://i.ibb.co/hM9zJFG/11.jpg`,
  },
  {
    code: 'post10',
    caption: 'Lekker Chocoladeletter',
    likes: 52,
    id: '1149382879529256679',
    display_src: `https://i.ibb.co/TgtYd9k/10.jpg`,
  },
  {
    code: 'post11',
    caption:
      'Just discovered the #hamont farmers market has a new ramen place! 🍜',
    likes: 35,
    id: '1147180903383025596',
    display_src: `https://i.ibb.co/sjKwTWT/12.jpg`,
  },
  {
    code: 'podt12',
    caption: '⛄️',
    likes: 64,
    id: '1143535906423162226',
    display_src: `https://i.ibb.co/C6RfvTf/22.jpg`,
  },

  {
    code: 'post13',
    caption: '6 page spread on flexbox in this months netmag!',
    likes: 74,
    id: '1141561999742846119',
    display_src: `https://i.ibb.co/Tcm5VS4/18.jpg`,
  },
  {
    code: 'post14',
    caption: 'Hanging out in my office waiting for 5:00 beers to come around.',
    likes: 54,
    id: '1137894817632733056',
    display_src: `https://i.ibb.co/kG9p3TJ/19.jpg`,
  },
  {
    code: 'post15',
    caption: "Today I learned that a long pull espresso is called a 'lungo'",
    likes: 18,
    id: '1136932306813044281',
    display_src: `https://i.ibb.co/znkyPGJ/20.jpg`,
  },
  {
    code: 'post16',
    caption: 'Awesome hand lettered gift from @eunibae and the HackerYou crew.',
    likes: 48,
    id: '1136502965197194931',
    display_src: `https://i.ibb.co/1v4Gzd7/17.jpg`,
  },

  {
    code: 'post17',
    caption:
      'Some serious hardware meet JavaScript hacks going down this week at hackeryou. Excited for demo day!',
    likes: 57,
    id: '1135147611821557699',
    display_src: `https://i.ibb.co/2vvBGGJ/23.jpg`,
  },

  {
    code: 'post18',
    caption: 'Some major audio upgrades coming to my next videos 😍',
    likes: 39,
    id: '1132002270913873708',
    display_src: `https://i.ibb.co/7pkc9yf/24.jpg`,
  },
  {
    code: 'post19',
    caption: 'My baby and me. Thanks to @bearandsparrow for this one.',
    likes: 81,
    id: '1128590547628442978',
    display_src: `https://i.ibb.co/CPSVJ2y/25.jpg`,
  },
  {
    code: 'post20',
    caption: "It's too early. Send coffee.",
    likes: 81,
    id: '1128237044221461933',
    display_src: `https://i.ibb.co/w0rDDXq/26.jpg`,
  },
  {
    code: 'post21',
    caption: 'They both have figured it out. #lifewithsnickers',
    likes: 47,
    id: '1127804966031967265',
    display_src: `https://i.ibb.co/5sw5VY8/27.jpg`,
  },
];

export default posts;
